export default __webpack_public_path__ + "static/media/EM1930.34I-42959_-25660_0.35e07550.jpg";